import React, { useMemo } from 'react';
import SearchSelect from 'components/fields/SearchSelect';
import type { CatalogIndustry } from 'views/backoffice/leads/BatiwebForwardCell';

// Produits du catalogue groupés par industrie, au format « industrie|produit ».
export const productOptions = (industries: CatalogIndustry[], onlyIndustry?: string) =>
    industries
        .filter((ind) => !onlyIndustry || ind.name === onlyIndustry)
        .flatMap((ind) => ind.subIndustries.map((sub) => ({ value: `${ind.name}|${sub.name}`, label: sub.name, group: ind.name, hint: ind.name })));

// Sélecteur de produit du catalogue avec recherche (produit ou industrie). Valeur « industrie|produit », '' = aucun.
export default function ProductPicker({
    industries,
    value,
    onChange,
    disabled,
}: {
    industries: CatalogIndustry[];
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}) {
    const options = useMemo(() => productOptions(industries), [industries]);
    return (
        <SearchSelect
            options={options}
            value={value}
            onChange={onChange}
            disabled={disabled}
            placeholder="Choisir un produit…"
            searchPlaceholder="Rechercher un produit ou une industrie"
        />
    );
}
